export type SiteLanguage = "en" | "fa";

const englishToPersian: Record<string, string> = {
  "/": "/fa/",
  "/about": "/fa/about",
  "/for-manufacturers": "/fa/suppliers",
  "/contact": "/fa/contact",
};

const persianToEnglish: Record<string, string> = Object.fromEntries(
  Object.entries(englishToPersian).map(([english, persian]) => [persian, english]),
);

export function isPersianPath(pathname: string) {
  return pathname === "/fa" || pathname.startsWith("/fa/");
}

export function normalizePath(pathname: string) {
  if (pathname === "/fa" || pathname === "/fa/") return "/fa/";
  if (pathname.length > 1 && pathname.endsWith("/")) return pathname.slice(0, -1);
  return pathname;
}

export function getLanguageSwitchPath(pathname: string) {
  const path = normalizePath(pathname);
  if (isPersianPath(path)) return persianToEnglish[path] ?? "/";
  return englishToPersian[path] ?? "/fa/";
}

export function getAlternatePath(pathname: string) {
  const path = normalizePath(pathname);
  return isPersianPath(path) ? persianToEnglish[path] : englishToPersian[path];
}

export const persianNavigation = [
  { label: "صفحه اصلی", href: "/fa/#top" },
  { label: "درباره ما", href: "/fa/about" },
  { label: "صنایع", href: "/fa/industries" },
  { label: "همکاری با تولیدکنندگان", href: "/fa/suppliers" },
  { label: "فرآیند همکاری", href: "/fa/#fa-process" },
  { label: "تماس با ما", href: "/fa/contact" },
] as const;
